export default {
  itemConnectFilter(condition) {
    return function (cuesheetStoreState) {
      condition = condition || ((row) => row.get('editing'));
      const rows = cuesheetStoreState.get('rows');
      if (!rows) return null;
      const rowIndex = rows.findIndex(condition),
        rowPath = cuesheetStoreState.getIn(['rows', rowIndex, 'path']),
        columnId = cuesheetStoreState.getIn([
          'rows',
          rowIndex,
          'editing',
          'value',
        ]);
      if (rowIndex === -1) return null;

      return {
        item: cuesheetStoreState.getIn(['rowMap'].concat(rowPath)),
        rowIndex,
        rowId: rowPath[2],
        columnId,
      };
    };
  },
};
